import React from "react";
import InnerBanner from "../UiComponents/InnerBanner";
import bannerImage from "../../assets/img/Offerings/DevOpsPracticeBanner.jpg";
// import ValueProposition from "../UiComponents/ValueProposition";
// import WrapValueProposition from "../UiComponents/WrapValueProposition";
import {
  FlipBlock,
  MainTitle,
  MetaHelmet
} from "../UiComponents/ContentBlocks";
import OfferingsObject from "./OfferingsObject";
import WrapValueProposition from "../UiComponents/WrapValueProposition";

export default function DevOpsPractice() {
  const root = OfferingsObject.DevOpsPractice;
  return (
    <React.Fragment>
      <MetaHelmet helmet={root.helmet} />
      <InnerBanner
        patch
        backgroundImage={bannerImage}
        bannerTitle={root.heroBanner.heading}
        featureParagraph={root.heroBanner.paragraph}
      />
      <WrapValueProposition
        image={root.CiCd.image}
        isOntop={true}
        title={root.CiCd.title}
        paragraph={root.CiCd.paragraph}
        list={root.CiCd.points}
        mainContainerClass="DevOpsCiCd"
      />
      <WrapValueProposition
        bgBlack
        image={root.Pipeline.image}
        isOntop={true}
        title={root.Pipeline.title}
        paragraph={root.Pipeline.paragraph}
        list={root.Pipeline.points}
        mainContainerClass="DevOpsPipeline"
      />

      <section className="sectionContainer DevOpsProductivity bgBlack">
        <div className="container">
          <MainTitle
            title={root.productivity.title.title}
            paragraph={root.productivity.title.paragraph}
          />
        </div>
        <div className="container">
          {root.productivity.points.map((item, index) => (
            <FlipBlock
              key={index.toString()}
              title={item.title}
              paragraph={item.paragraph}
              iconimages={item.icon}
            />
          ))}
        </div>
      </section>

      {/* <WrapValueProposition
        image={root.agilePipelines.image}
        isOntop={true}
        customContainer={"agilePipelines"}
        mainContainerClass="bgDark"
        title={root.agilePipelines.title}
        paragraph={root.agilePipelines.paragraph}
        list={root.agilePipelines.points}
      />

      <WrapValueProposition
        image={root.labOps.image}
        isOntop={true}
        title={root.labOps.title}
        paragraph={root.labOps.paragraph}
        list={root.labOps.points}
      />

      <ValueProposition
        image={root.reliabilityEngineering.image}
        isOntop={true}
        mainContainerClass="bgDark"
        title={root.reliabilityEngineering.title}
        paragraph={root.reliabilityEngineering.paragraph}
        list={root.reliabilityEngineering.points}
      />
      <ValueProposition
        image={root.cloudService.image}
        customConiainer="flip"
        customtextcontainer="flipped-text-container"
        title={root.cloudService.title}
        paragraph={root.cloudService.paragraph}
        list={root.cloudService.points}
      /> */}
    </React.Fragment>
  );
}
